import { api, throwApiError } from "./api";

/** Aviso do sino do staff (plan-notificacoes-whatsapp, 22/10/2026). */
export type StaffNotification = {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  /** Caminho no app: `/dp`, `/operacoes/cobertura-semanal?semana=…`. */
  link: string | null;
  readAt: string | null;
  createdAt: string;
};

export type NotificationsPage = { page: number; limit: number; total: number; items: StaffNotification[] };

export async function listNotificationsApi(params: { unread?: boolean; page?: number; limit?: number } = {}): Promise<NotificationsPage> {
  try {
    const { data } = await api.get<NotificationsPage>("/notifications", { params });
    return data;
  } catch (error) {
    return throwApiError(error, "Não foi possível carregar os avisos.");
  }
}

export async function unreadNotificationsCountApi(): Promise<number> {
  try {
    const { data } = await api.get<{ unread: number }>("/notifications/unread-count");
    return data.unread;
  } catch (error) {
    return throwApiError(error, "Não foi possível carregar os avisos.");
  }
}

export async function markNotificationReadApi(id: string): Promise<void> {
  try {
    await api.post(`/notifications/${id}/read`);
  } catch (error) {
    throwApiError(error, "Não foi possível marcar o aviso como lido.");
  }
}

export async function markAllNotificationsReadApi(): Promise<void> {
  try {
    await api.post("/notifications/read-all");
  } catch (error) {
    throwApiError(error, "Não foi possível marcar os avisos como lidos.");
  }
}

/** Disparado quando um aviso é lido em algum lugar: o sino e o destaque da home se atualizam. */
export const NOTIFICATIONS_CHANGED_EVENT = "eco:notifications-changed";

export const notifyNotificationsChanged = () => window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
